import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_ENABLED, WHATSAPP_HREF } from "@/lib/contact";
import { track } from "@/lib/analytics";

export default function WhatsAppFab() {
  if (!WHATSAPP_ENABLED) return null;
  return (
    <a
      href={WHATSAPP_HREF}
      onClick={() => track.whatsapp("fab")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contattaci su WhatsApp"
      className="fixed right-4 bottom-24 md:bottom-6 z-50 grid place-items-center h-14 w-14 rounded-full bg-whatsapp text-white shadow-lg btn-glow-green animate-pulse-ring-green hover:-translate-y-0.5 hover:brightness-110 transition"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
